class PricingService {
    axiosInstance;
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    salesTax = {
        query: async (input) => {
            const response = await this.axiosInstance.mainInstance.post(`/pricing/sales-tax`, input);
            return response.data;
        },
    };
    zip = {
        query: async (input) => {
            const response = await this.axiosInstance.mainInstance.get(`/pricing/zip`, {
                params: { zips: input },
            });
            return response.data;
        },
    };
    /////////////////////////// BILLING SECTION FOR UNIVERSAL SERVICES ///////////////////////////
    adminPortal = {
        pricing: {
            query: async (input) => {
                const response = await this.axiosInstance.mainInstance.get(`/pricing/admin-portal`, {
                    params: input,
                });
                return response.data;
            },
            fetch: async (id, withHistorical) => {
                const response = await this.axiosInstance.mainInstance.get(`/pricing/admin-portal/${id}`, {
                    params: { withHistorical: withHistorical || false },
                });
                return response.data;
            },
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post(`/pricing/admin-portal`, input);
                return response.data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.put(`/pricing/admin-portal/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const { data } = await this.axiosInstance.mainInstance.delete(`/pricing/admin-portal/${id}`);
                return data;
            },
        },
        commercial: {
            query: async (input) => {
                const response = await this.axiosInstance.mainInstance.get(`/pricing/commercial`, { params: input });
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/pricing/commercial/${id}`);
                return response.data;
            },
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post(`/pricing/commercial`, input);
                return response.data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/pricing/commercial/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/pricing/commercial/${id}`);
                return response.data;
            },
            addServiceAreas: async (id, serviceAreas) => {
                const response = await this.axiosInstance.mainInstance.post(`/pricing/commercial/${id}/service-area`, serviceAreas);
                return response.data;
            },
        },
        serviceArea: {
            update: async (pricingId, serviceAreas) => {
                const response = await this.axiosInstance.mainInstance.post(`/pricing/admin-portal/${pricingId}/service-area/replace`, serviceAreas);
                return response.data;
            },
        },
        material: {
            create: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.post(`/pricing/admin-portal/${id}/material`, input);
                return response.data;
            },
            createMany: async (pricingZoneId, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/pricing/admin-portal/${pricingZoneId}/material/bulk`, input);
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.post(`/pricing/admin-portal/${id}/material`, input);
                return response.data;
            },
        },
        customerDiscount: {
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/pricing/customer-discounts/${id}`);
                return response.data;
            },
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/pricing/customer-discounts', input);
                return response.data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.put(`/pricing/customer-discounts/${id}`, input);
                return response.data;
            },
            query: async (input) => {
                const response = await this.axiosInstance.mainInstance.get('/pricing/customer-discounts', {
                    params: input,
                });
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/pricing/customer-discounts/${id}`);
                return response.data;
            },
        },
        location: {
            query: async (coords, customerID) => {
                const response = await this.axiosInstance.mainInstance.get(`/pricing/by-service-location-full`, {
                    params: { ...coords, customerID: customerID || undefined },
                });
                return response.data;
            },
        },
    };
    /**
     * Represents the customer portal functionality of the Pricing service.
     */
    customerPortal = {
        location: {
            query: async (coordinates) => {
                const response = await this.axiosInstance.mainInstance.get(`/pricing/by-service-location`, {
                    params: coordinates,
                });
                return response.data;
            },
        },
        signed: {
            create: async (input) => {
                const res = await this.axiosInstance.mainInstance.post('/pricing/signed', input);
                return res.data;
            },
        },
    };
    wayste = {
        pricing: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post(`/pricing/hauler`, input);
                return response.data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.put(`/pricing/hauler/${id}`, input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/pricing/hauler/${id}`);
                return response.data;
            },
            query: async (opts = {}) => {
                const res = await this.axiosInstance.mainInstance.get(`/pricing/hauler`, {
                    params: opts,
                });
                return res.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/pricing/hauler/${id}`);
                return response.data;
            },
            replaceAllServiceAreas: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.post(`/pricing/hauler/${id}/service-area/replace`, input);
                return response.data;
            },
        },
        discount: {
            query: async (input) => {
                const response = await this.axiosInstance.mainInstance.get(`/pricing/customer-discounts/hauler`, {
                    params: input,
                });
                return response.data;
            },
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post(`/pricing/customer-discounts/hauler`, input);
                return response.data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.put(`/pricing/customer-discounts/${id}/hauler`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/pricing/customer-discounts/${id}/hauler`);
                return response.data;
            },
        },
        material: {
            create: async (haulerPricingZoneId, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/pricing/hauler/${haulerPricingZoneId}/material`, input);
                return data;
            },
            createMany: async (haulerPricingZoneId, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/pricing/hauler/${haulerPricingZoneId}/material/bulk`, input);
                return data;
            },
            delete: async (haulerPricingZoneId, materialId) => {
                const { data } = await this.axiosInstance.mainInstance.delete(`/pricing/hauler/${haulerPricingZoneId}/material/${materialId}`);
                return data;
            },
        },
        fee: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/pricing/hauler/fees', input);
                return response.data;
            },
            // TODO no backend transport type for this
            query: async (input) => {
                const response = await this.axiosInstance.mainInstance.get('/pricing/hauler/fees', { params: input });
                return response.data;
            },
            update: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/pricing/hauler/fees', input);
                return response.data;
            },
            // TODO no backend transport type for this
            attachZone: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/pricing/hauler/fees/attach', input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/pricing/hauler/fees/${id}`);
                return response.data;
            },
        },
    };
}
export default PricingService;
//# sourceMappingURL=Pricing.service.js.map